import {
  BackTestResponse,
  FundBasket,
  FundBasketAnalytics,
  FundBasketChartData,
  FundBasketClients,
  FundBasketCreateUpdate,
  FundBasketSummary,
} from "../../types";
import { api } from "../axios";

export type ListFundBasketsParams = {
  strategy?: string[];
  tenure?: string[];
};

export function getFundBaskets(params?: ListFundBasketsParams): Promise<{
  custom_baskets: FundBasketSummary[];
  curated_baskets: FundBasketSummary[];
}> {
  return api.get("fund-baskets/", {
    params: {
      strategy: params?.strategy?.join(","),
      tenure: params?.tenure?.join(","),
    },
  });
}

export function createFundBasket(
  data: FundBasketCreateUpdate
): Promise<FundBasket> {
  return api.post("fund-baskets/", data);
}

export function getFundBasket(id: number): Promise<FundBasket> {
  return api.get(`fund-baskets/${id}/`);
}

export function updateFundBasket(
  payload: FundBasketCreateUpdate & { id: number }
): Promise<FundBasket> {
  const { id, ...data } = payload;
  return api.put(`fund-baskets/${id}/`, data);
}

export function deleteFundBasket(id: number): Promise<void> {
  return api.delete(`fund-baskets/${id}/`);
}

export function getFundBasketAnalytics(
  id: number,
  benchmark?: string
): Promise<FundBasketAnalytics> {
  return api.get(`fund-baskets/${id}/analytics/`, {
    params: { benchmark },
  });
}

export function getFundBasketChart(payload: {
  id: number;
  period: "YTD" | "1M" | "3M" | "1Y" | "3Y" | "5Y";
  benchmark?: string;
}): Promise<FundBasketChartData> {
  return api.get(`fund-baskets/${payload.id}/chart/`, {
    params: { period: payload.period || "1Y", benchmark: payload.benchmark },
  });
}

export function getBacktestedFundBasketData(payload: {
  id: number;
  initialAmount: number;
  sipAmount: number;
  period: "1Y" | "3Y" | "5Y" | "10Y";
  benchmark?: string;
}): Promise<BackTestResponse> {
  const { id, initialAmount, sipAmount, period, benchmark } = payload;
  return api.get(`fund-baskets/${id}/backtest/`, {
    params: {
      initial_amount: initialAmount,
      sip_amount: sipAmount,
      period,
      benchmark,
    },
  });
}

export function getFundBasketClients(
  id?: number
): Promise<FundBasketClients[]> {
  return api.get(`fund-baskets/clients/`, {
    params: {
      basket_id: id,
    },
  });
}

export function notifyFundBasketRebalance(id: number) {
  return api.post(`fund-baskets/${id}/linked-sips/notify/`);
}
